const DATAURL = {
    QUERYSETTINGURL: "/platform/appregister/querypersonsettings.do", // 用户信息查询接口
    QUERYUSERIMAGEURL: "/platform/userimage/queryuserimage.do", // 用户头像查询接口
    MERGEREQUESTURL: "/nccloud/platform/pub/mergerequest.do" // 合并请求接口
};
export default DATAURL;
